<template>
  <div class="centerBox">
    <!-- 列表主体 -->
    <div
      :class="{
        noticeBox: true,
        noticeBox2: item.commonContent == '',
      }"
      v-for="(item, index) in arrList"
      :key="index"
    >
      <div class="imgBox">
        <el-image
          :src="item.logo"
          fit="cover"
          class="img"
          @click="toUser(item, index)"
        >
          <img
            width="48"
            height="48"
            slot="error"
            class="error-headImg"
            @click="toUser(item, index)"
            :src="$utils.getPng('icon-gfans-defaultHead')"
          />
        </el-image>
        <div v-show="item.isrd == 0" class="red"></div>
      </div>
      <!-- 评论回复 点赞/收藏/关注 -->
      <div
        class="rightNotice"
        @click="toUrl(item, index)"
        v-show="isType == 4 || isType == 3"
      >
        <div class="timeBox">
          <div class="noteF">
            {{ item.nickname }}
          </div>
          <div class="noteF1">{{ item.in_time }}</div>
        </div>
        <div
          :class="{
            noteF2: true,
            noteF22: item.commonContent == '',
          }"
        >
          {{ item.title }}
        </div>
        <div class="noteF3" v-show="isType != 3" v-html="item.msgChild"></div>
        <div class="btBox" v-show="item.commonContent">
          {{ item.commonContent }}
        </div>
      </div>

      <!-- 官方消息 -->
      <div class="rightNotice" @click="toUrl(item, index)" v-show="isType == 2">
        <div class="timeBox">
          <div class="noteF">{{ item.label }}</div>
          <div class="noteF1">{{ item.in_time }}</div>
        </div>
        <div class="noteF4">{{ item.title }}</div>
        <div class="noteF5">{{ item.child }}</div>
        <el-image
          v-show="item.img_url"
          :src="item.img_url"
          fit="cover"
          class="imgc"
        >
          <span class="loadFail" slot="error">
            <svg-btn class="failIcon" icon-class="icon-gfans-imgNo" />
          </span>
        </el-image>
        <div
          @click.stop="toUrl(item, index)"
          v-show="item.jump_url != ''"
          class="noteF6Box"
        >
          <div class="noteF6">去查看</div>
          <svg-btn class="rightIcon" icon-class="icon-right"></svg-btn>
        </div>
      </div>

      <!-- 系统通知 -->
      <div class="rightNotice" @click="toUrl(item, index)" v-show="isType == 1">
        <div class="timeBox">
          <div class="noteF">{{ item.label }}</div>
          <div class="noteF1">{{ item.in_time }}</div>
        </div>
        <div class="noteF7">{{ item.title }}</div>
        <div v-if="isString(item.child)" class="noteF9">{{ item.child }}</div>
        <div v-else-if="isArray(item.child)">
          <div class="content" v-for="(itn, idx) in item.child" :key="idx">
            <div class="noteF8">{{ itn.name }}：</div>
            <div
              :class="{
                noteF9: true,
                noteF10: itn.is_color && itn.is_color == 1,
                noteF11: itn.is_color && itn.is_color == 2,
              }"
            >
              {{ itn.value }}
            </div>
          </div>
        </div>
        <div
          @click.stop="toUrl(item, index)"
          v-show="item.jump_url != ''"
          class="noteF6Box"
        >
          <div class="noteF6">去查看</div>
          <svg-btn class="rightIcon" icon-class="icon-right"></svg-btn>
        </div>
      </div>
    </div>
    <!-- 底部加载触发器 -->
    <div
      v-show="arrList.length > 0"
      ref="loadMoreTrigger"
      class="load-more-trigger"
    ></div>
    <!-- 底部加载状态 -->
    <div class="loadStatus" v-show="arrList.length > 0">
      <div v-show="isLoading" class="loadBox">
        <div class="spinner"></div>
        <span class="not">加载中</span>
      </div>
      <div class="not" v-show="noMoreData">暂无更多消息</div>
    </div>
  </div>
</template>

<script>
import { checkRed } from '@/axios/notice'
import { eventBus } from '@/utils/event-bus'
export default {
  props: {
    //数组
    arrList: { type: Array, required: true, default: () => [] },
    //数据是否正在加载
    isLoading: {
      type: Boolean,
      default: false,
    },
    //是否没有更多数据
    noMoreData: {
      type: Boolean,
      default: false,
    },
    //判断类型，4是评论回复，3是点赞/收藏/关注 2是官方消息 1是系统通知
    isType: {
      type: [String, Number],
      default: 4,
    },
  },
  computed: {
    //判断是否是字符串
    isString() {
      return value => typeof value === 'string' || value instanceof String
    },
    //判断是否是数组
    isArray() {
      return value => Array.isArray(value)
    },
  },
  data() {
    return {
      loadMoreObserver: null, // 加载触发观察器
      loadMoreDistance: 200, // 距离底部多少像素触发加载
    }
  },
  mounted() {
    // 设置加载触发观察
    this.$nextTick(() => {
      this.setupLoadMoreObserver()
    })
  },
  beforeUnmount() {
    this.loadMoreObserver?.disconnect()
    this.loadMoreObserver = null
  },
  methods: {
    //点击事件
    toUrl: _.debounce(
      function (item, index) {
        if (this.arrList[index].isrd == 0) {
          this.checkRedUp(item)
          this.arrList[index].isrd = 1
        }
        //评论回复/点赞收藏关注
        if ((this.isType == 3 || this.isType == 4) && item.commonId) {
          if (item.is_del == 1) {
            this.$toast('该帖子已被作者删除', 2)
            return
          }
          const routeParams = {
            name: item.t_type,
            params: { id: item.commonId },
          }
          // 条件判断是否添加query参数
          if (item.amount != -1) {
            routeParams.query = {
              with_cthis: item.amount,
            }
          }
          const route = this.$router.resolve(routeParams)
          window.open(route.href, '_blank')
          return
        }
        //官方消息跳转
        if ((this.isType == 1 || this.isType == 2) && item.jump_url) {
          window.open(item.jump_url, '_blank')
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //跳转帖子详情页
    toDetail: _.debounce(
      function (item, index) {
        if (this.arrList[index].isrd == 0) {
          this.checkRedUp(item)
          this.arrList[index].isrd = 1
        }
        const route = this.$router.resolve({
          name: item.t_type,
          params: { id: item.commonId },
          query: {
            with_cthis: item.amount,
          },
        })
        window.open(route.href, '_blank')
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //跳转个人中心
    toUser: _.debounce(
      function (item, index) {
        if (this.arrList[index].isrd == 0) {
          this.checkRedUp(item)
          this.arrList[index].isrd = 1
        }
        if ((this.isType == 3 || this.isType == 4) && item.userid) {
          this.$router.push({
            name: 'user',
            params: { uid: item.userid },
          })
        }
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //单条消息标记已读
    async checkRedUp(item) {
      checkRed({ id: item.msg_id, stype: item.stype })
        .then(res => {
          if (res.status == 1) {
            eventBus.$emit('getMsg')
          } else {
          }
        })
        .catch(error => {})
    },
    //观察器，判断什么时候可以加载滚动
    setupLoadMoreObserver() {
      if (!('IntersectionObserver' in window)) return

      const trigger = this.$refs.loadMoreTrigger
      if (!trigger) return
      let loadMoreThrottle = false

      this.loadMoreObserver = new IntersectionObserver(
        entries => {
          // 处理所有可见性变化的条目
          entries.forEach(entry => {
            if (
              entry.isIntersecting &&
              !this.noMoreData &&
              !this.isLoading &&
              !loadMoreThrottle
            ) {
              loadMoreThrottle = true
              requestAnimationFrame(() => {
                this.$emit('load-more')
                setTimeout(() => {
                  loadMoreThrottle = false
                }, 300) // 300ms内只触发一次加载
              })
            }
          })
        },
        {
          rootMargin: `0px 0px ${this.loadMoreDistance}px 0px`,
          threshold: 0.1, // 元素10%可见即触发
        }
      )
      this.loadMoreObserver.observe(trigger)
    },
  },
}
</script>

<style lang="scss" scoped>
.centerBox {
  border-radius: 16px 16px 0px 0px;
  height: 100%;
  display: flex;
  margin-top: 0 !important;
  @include useTheme {
    background: getVar('bg-color-content');
  }
  .noticeBox {
    padding: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    @include useTheme {
      box-shadow: inset 0px -1px 0px 0px getVar('border-color2-f2f4f6');
    }
    .imgBox {
      position: relative;
      width: 48px;
      height: 48px;
      margin-right: 12px;
      cursor: pointer;
      .img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
      .red {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        position: absolute;
        top: 0px;
        right: -3px;
        @include useTheme {
          background-color: getVar('bg-color4-f53f3f') !important;
        }
      }
    }
    .rightNotice {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex: 1;
      cursor: pointer;
      .timeBox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .noteF {
          font-weight: 600;
          font-size: 14px;
          line-height: 22px;
          @include multiline(1);
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .noteF1 {
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          margin-left: 10px;
          white-space: nowrap;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .noteF2 {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 4px;
        @include multiline(1);

        @include useTheme {
          color: getVar('text-color3-90969c');
        }
      }
      .noteF22 {
        margin-bottom: 0 !important;
      }
      .noteF3 {
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        white-space: pre-line;
        @include multiline(2);
        @include useTheme {
          color: getVar('text-color8-52565a');
        }
      }
      .noteF4 {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-top: 8px;
        margin-bottom: 2px;
        @include multiline(1);

        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
      }
      .noteF5 {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        margin-bottom: 12px;
        word-break: break-all;
        // @include multiline(1);
        @include useTheme {
          color: getVar('text-color8-52565a');
        }
      }
      .imgc {
        max-width: 354px;
        width: 100% !important;
        height: 196px;
        object-fit: cover;
        border-radius: 16px;
        .loadFail {
          max-width: 354px;
          width: 100% !important;
          height: 196px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 16px;
          @include useTheme {
            background: getVar('bg-color10-f4f6f8');
          }
          .failIcon {
            width: 64px;
            height: 64px;
          }
        }
      }

      .noteF6Box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: 12px;
        .noteF6 {
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          cursor: pointer;
          @include useTheme {
            color: getVar('text-color1-2c2c2c');
          }
        }
        .rightIcon {
          width: 16px;
          height: 16px;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .noteF7 {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        width: 100%;
        margin: 8px 0 6px 0;
        @include multiline(1);
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
      }
      .content {
        display: flex;
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
        .noteF8 {
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          flex-shrink: 0;
          @include useTheme {
            color: getVar('text-color3-90969c');
          }
        }
      }
      .noteF9 {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        word-break: break-all;
        // @include multiline(1);
        @include useTheme {
          color: getVar('text-color1-2c2c2c');
        }
      }
      .noteF10 {
        color: getVar('bg-color4-f53f3f') !important;
      }
      .noteF11 {
        color: getVar('primary-color') !important;
      }
      .btBox {
        padding: 4px 6px 2px 6px;
        border-radius: 2px;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 4px;
        word-break: break-all;
        // @include multiline(1);
        @include useTheme {
          color: getVar('text-color3-90969c');
          background: getVar('bg-color1-f4f6f8');
        }
      }
    }
  }
  .noticeBox2 {
    align-items: center !important;
  }
  .load-more-trigger {
    height: 1px; /* 不可见元素，仅用于触发观察器 */
  }
  .loadStatus {
    padding: 32px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .loadBox {
      display: flex;
      align-items: center;
      justify-content: center;
      .spinner {
        border: 3px solid rgba(5, 216, 196, 0.2);
        border-radius: 50%;
        width: 18px;
        height: 18px;
        animation: spin 1s linear infinite;
        margin-right: 10px;
        @include useTheme {
          border-top: 3px solid getVar('primary-color');
        }
      }
    }
    .not {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      @include useTheme {
        color: getVar('text-color6-b8bec4');
      }
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
